"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.childToString = void 0;
var react_1 = require("react");
var hasChildren_1 = __importDefault(require("./hasChildren"));
var childToString = function (child) {
    if (typeof child === "undefined" ||
        child === null ||
        typeof child === "boolean") {
        return "";
    }
    if (JSON.stringify(child) === "{}") {
        return "";
    }
    return child.toString();
};
exports.childToString = childToString;
var onlyText = function (children) {
    if (!(children instanceof Array) && !(0, react_1.isValidElement)(children)) {
        return (0, exports.childToString)(children);
    }
    return react_1.Children.toArray(children).reduce(function (text, child) {
        var newText = "";
        if ((0, react_1.isValidElement)(child) && (0, hasChildren_1.default)(child)) {
            newText = onlyText(child.props.children);
        }
        else if ((0, react_1.isValidElement)(child) && !(0, hasChildren_1.default)(child)) {
            newText = "";
        }
        else {
            newText = (0, exports.childToString)(child);
        }
        return text.concat(newText);
    }, "");
};
exports.default = onlyText;
//# sourceMappingURL=onlyText.js.map